import { isPlatformBrowser, registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import localeEN from '@angular/common/locales/en';
import localeUK from '@angular/common/locales/uk';
import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DefaultMatCalendarRangeStrategy, MatRangeDateSelectionModel } from '@angular/material/datepicker';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimations, provideNoopAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { provideCoreConfig } from './core/core.config';
import { provideExternalReferrer } from './core/providers/external-referrer.provider';
import { provideMaterialIconsConfig } from './shared/material-icon.config';

registerLocaleData(localeEN);
registerLocaleData(localeUK);

export const MY_FORMATS = {
  ...MAT_MOMENT_DATE_FORMATS,
  display: {
    ...MAT_MOMENT_DATE_FORMATS.display,
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
  },
};

const ICONS: Record<string, string> = {
  mark_wb_sunny: 'assets/svg/mark_wb_sunny.svg',
  mark_check: 'assets/svg/mark_check.svg',
  mark_column: 'assets/svg/mark_column.svg',
  mark_warning: 'assets/svg/mark_warning.svg',
  mark_info: 'assets/svg/mark_info.svg',
  calendar: 'assets/svg/calendar.svg',
  mark_document: 'assets/svg/mark_document.svg',
  mark_success: 'assets/svg/mark_success.svg',
  mark_error: 'assets/svg/mark_error.svg',
  mark_send_email: 'assets/svg/mark_send_email.svg',
  mark_send_phone: 'assets/svg/mark_send_phone.svg',
  mark_link: 'assets/svg/mark_link.svg',
  mark_link_2: 'assets/svg/mark_link_2.svg',
  mark_copy: 'assets/svg/mark_copy.svg',
  mark_share: 'assets/svg/mark_share.svg',
  mark_arrow: 'assets/svg/mark_arrow.svg',
  mark_arrow2: 'assets/svg/mark_arrow2.svg',
  mark_logo: 'assets/svg/mark_logo.svg',
  error_server: 'assets/svg/error_server.svg',
  error_404: 'assets/svg/error_404.svg',
  chevron_top: 'assets/svg/landing/chevron_top.svg',
  /** LANDING */
  star: 'assets/svg/landing/star.svg',
  goal_achievement: 'assets/svg/landing/goal_achievement.svg',
  goal_box: 'assets/svg/landing/goal_box.svg',
  goal_star: 'assets/svg/landing/goal_star.svg',
  star_quotes: 'assets/svg/landing/star_quotes.svg',
  long_arrow: 'assets/svg/landing/long_arrow.svg',
  close: 'assets/svg/landing/close.svg',
  menu: 'assets/svg/landing/menu.svg',
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideCoreConfig(),
    provideMaterialIconsConfig(ICONS),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({ anchorScrolling: 'enabled' }),
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
    ),
    provideExternalReferrer(),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch()),
    { provide: MAT_DATE_LOCALE, useValue: 'en' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    DefaultMatCalendarRangeStrategy,
    MatRangeDateSelectionModel,
    provideHttpClient(withInterceptorsFromDi()),
    ...(isPlatformBrowser(typeof globalThis !== 'undefined' ? 'browser' : 'server')
      ? [provideAnimations()]
      : [provideNoopAnimations()]),
  ],
};
